import React, { useState, useEffect, useRef } from 'react'
import ImageComponent from '../../common/Image';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchNotification } from '../../../slices/dashboard/dashboardSlice';
import Loader from '../../common/Loader';
import { toast } from 'react-toastify';

function NotificationContent() {

    const { notifications } = useSelector((state) => state.dashboard);
    const { userData } = useSelector((state) => state.auth);
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [loader, setLoader] = useState(false);
    const [show, setShow] = useState(false);

    const fetchAllNotification = () => {
        setLoader(true)
        dispatch(fetchNotification({ source_by: userData?.response_data?.data?.userID }))
            .unwrap()
            .then((res) => {
                if (res?.response_code === "S100") {
                } else {
                    toast.error(res?.response_string);
                }
            })
            .catch((error) => {
                toast.error(error?.message);
            })
            .finally(() => {
                setLoader(false);
            });
    }

    useEffect(() => {
        fetchAllNotification()
    }, [dispatch])

    return (
        <>
            {loader === true && <Loader />}
            <div className=" container-fluid  kyc-tab-dash-app height-scroll text-center">
                {(Array.isArray(notifications) ? notifications : [])?.length === 0 &&
                    <>
                        <ImageComponent fileName="noti.svg" alt="noti" />
                        <p className="fw-semibold mt-3">No notifications at the moment...</p>
                    </>
                }
                {(notifications && notifications.length !== 0) &&
                    <div className="row gy-2">
                        {(Array.isArray(notifications) ? notifications : []).map(data => (
                            <div className="col-md-12"
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        setShow(data)
                                    }
                                }}
                                onClick={() => { setShow(data) }}>
                                <div className="db-item border-0 position-relative">
                                    <div className="name-detail-app align-items-center ">
                                        <div>
                                            <p className="fw-semibold mb-0 small">{data?.customer_name || "-"}</p>
                                            <ul>
                                                <li className="small text-body-secondary">{data?.is_tc_lead ? data?.exsisting_loan_id : data?.reference_id}</li>
                                            </ul>
                                        </div>
                                        <div>
                                            <span className="badge consumer-invoice  fs-6">{data?.action}</span>
                                        </div>
                                    </div>
                                    <div className={`ribbon ${data?.is_tc_lead ? "inprogress" : "invoice-details"}`}>{data?.is_tc_lead ? 'Leads' : 'Invoice Details'}</div>

                                    {!data?.is_tc_lead &&
                                        <div className="dash-table d-flex justify-content-end">
                                            <div className=" col-4 col-sm-4">
                                                <p><label className="fw-normal">Invoice Number</label>
                                                    <p className="text-body-secondary fw-semibold">{data?.invoice_number || "-"}</p>
                                                </p>
                                            </div>
                                            <div className=" col-4 col-sm-4">
                                                <p><label className="fw-normal">Created Date</label>
                                                    <p className="text-body-secondary fw-semibold">{data?.invoice_date || "-"}</p>
                                                </p>
                                            </div>
                                            <div className="col-4 col-sm-4">
                                                <p><label className="fw-normal">Invoice Amount</label>
                                                    <p className="text-body-secondary fw-semibold">
                                                        {data?.invoice_amount ? <><span className="font-serif mx-1">₹</span>{Number(data?.invoice_amount).toLocaleString('en-IN')}</> : "-"}
                                                    </p>
                                                </p>
                                            </div>
                                        </div>}
                                    {data?.is_tc_lead &&
                                        <div className="dash-table d-flex justify-content-end">
                                            <div className=" col-4 col-sm-4">
                                                <p><label className="fw-normal">Lead ID</label>
                                                    <p className="text-body-secondary fw-semibold">{data?.reference_id || "-"}</p>
                                                </p>
                                            </div>
                                            <div className="col-4 col-sm-4">
                                                <p><label className="fw-normal">Brand</label>
                                                    <p className="text-body-secondary fw-semibold">{data?.brand || "-"}</p>
                                                </p>
                                            </div>
                                            <div className="d-none col-4 col-sm-4">
                                                <p><label className="fw-normal">Mobile No</label>
                                                    <p className="text-body-secondary fw-semibold">{data?.cust_mobile || "-"}</p>
                                                </p>
                                            </div>
                                            <div className=" col-4 col-sm-4">
                                                <p><label className="fw-normal">Interested Product</label>
                                                    <p className="text-body-secondary fw-semibold">{data?.product || "-"}</p>
                                                </p>
                                            </div>
                                        </div>}
                                </div>
                            </div>
                        ))}

                        {/* <div className="col-md-12 ">
                            <div className="d-flex bg-white align-items-center justify-content-between scheme-t">
                                <p className="m-0 fw-semibold">
                                    Scheme Chart
                                </p>
                                <p className="m-0 fw-semibold">
                                    <span className="icon-arrowright-L1"></span>
                                </p>
                            </div>
                        </div>

                        <div className="col-md-12 ">
                            <div className="d-flex bg-white align-items-center justify-content-between scheme-t">
                                <p className="m-0 fw-semibold">
                                    Product live
                                </p>
                                <p className="m-0 fw-semibold">
                                    <span className="icon-arrowright-L1"></span>
                                </p>
                            </div>
                        </div>

                        <div className="col-md-12 ">
                            <div className="d-flex bg-white align-items-center justify-content-between scheme-t">
                                <p className="m-0 fw-semibold">
                                    Incentive Update
                                </p>
                                <p className="m-0 fw-semibold">
                                    <span className="icon-arrowright-L1"></span>
                                </p>
                            </div>
                        </div> */}
                    </div>
                }
            </div>
            {show &&
                <>
                    <div
                        className="modal show fade"
                        id="searchrole"
                        style={{ display: "block" }}
                        aria-labelledby="existingcred"
                        tabIndex={-1}
                        onClick={() => setShow(false)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                setShow(false);
                            }
                        }}>
                        <div className="modal-dialog bottom-modal">
                            <div className="modal-content"
                                onClick={(e) => e.stopPropagation()}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.stopPropagation();
                                    }
                                }}>
                                <div className="px-3 py-3 text-center">
                                    <div className="row mt-3 p-3 gy-2">
                                        <div className="exist-pop">
                                            {show?.ops_remarks?.map((data) => (<div className="col-12 col-lg-12 col-md-12">
                                                <p className=" d-flex justify-content-between">* {data?.remark || "-"}</p>
                                            </div>
                                            ))}
                                        </div>
                                        {!show?.is_tc_lead && <div className="d-flex justify-content-center mt-3">
                                            <button
                                                className="btn btn-primary btn-lg w-50 signin"
                                                type="submit"
                                                onClick={() => {
                                                    navigate(`/consumerId?referenceId=${show?.reference_id}`);
                                                    setShow();
                                                }}
                                            >
                                                Proceed
                                            </button>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show"></div>
                </>}
        </>
    )
}

export default NotificationContent